import { useCallback, useMemo, useState } from 'react';

import { GridRowId } from '@mui/x-data-grid';
import map from 'lodash/map';

type DetailPanelExpansionProps = { id?: string }[];
export const useDetailPanelExpansion = (data: DetailPanelExpansionProps) => {
  const [detailPanelExpandedRowIds, setDetailPanelExpandedRowIds] = useState<
    Set<GridRowId>
  >(new Set());

  const onDetailPanelExpandedRowIdsChange = useCallback(
    (ids: Set<GridRowId>) => {
      setDetailPanelExpandedRowIds(ids);
    },
    []
  );

  const expandAll = useCallback(() => {
    const idsSet = new Set(map(data, (item) => item.id as string));
    setDetailPanelExpandedRowIds(idsSet);
  }, [data]);

  const collapseAll = useCallback(() => {
    setDetailPanelExpandedRowIds(new Set());
  }, []);

  const ids = useMemo(
    () => Array.from(detailPanelExpandedRowIds),
    [detailPanelExpandedRowIds]
  );
  return {
    ids,
    detailPanelExpandedRowIds,
    onDetailPanelExpandedRowIdsChange,
    expandAll,
    collapseAll,
  };
};
export default useDetailPanelExpansion;

export type DetailPanelExpansionType = ReturnType<
  typeof useDetailPanelExpansion
>;
